var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { compose, path, pathOr, pluck } from 'ramda';
import { filterBy, getEntityMeta, createCustomDeepResultObject } from 'utils/helpers';
import { EDGES_PATH, NODE_PATH, NODES_PATH } from 'constants/dataPaths';
export var getPageInfo = function (dataPath) {
    return pathOr({}, __spreadArray(__spreadArray([], dataPath, true), ['pageInfo'], false));
};
export var safeFetchMore = function (fetchMore) { return __awaiter(void 0, void 0, void 0, function () {
    var err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, fetchMore()];
            case 1:
                _a.sent();
                return [3 /*break*/, 3];
            case 2:
                err_1 = _a.sent();
                if (err_1 instanceof Error) {
                    console.assert(err_1.name === 'Invariant Violation', err_1);
                }
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var cursorFetchMore = function (fetchMore) {
    return function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var dataPath = _b.dataPath, dataType = _b.dataType, pageInfo = _b.pageInfo, first = _b.first, _c = _b.setScrollLoading, setScrollLoading = _c === void 0 ? null : _c, _d = _b.filterUniqueIds, filterUniqueIds = _d === void 0 ? false : _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0: return [4 /*yield*/, safeFetchMore(function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, fetchMore({
                                    variables: __assign({ cursor: pageInfo.endCursor }, (first && { first: first })),
                                    // Apollo expects fetchMoreResult to be `Unmasked<TData>`
                                    updateQuery: function (previousResult, _a // TS sees Unmasked<TData> internally
                                    ) {
                                        var _b;
                                        var fetchMoreResult = _a.fetchMoreResult;
                                        if (!fetchMoreResult)
                                            return previousResult;
                                        var newNodes = path(__spreadArray(__spreadArray([], dataPath, true), [dataType], false), fetchMoreResult) || [];
                                        var prevNodes = path(__spreadArray(__spreadArray([], dataPath, true), [dataType], false), previousResult) || [];
                                        var nodesArray = __spreadArray(__spreadArray([], prevNodes, true), newNodes, true);
                                        var newPageInfo = getPageInfo(dataPath)(fetchMoreResult);
                                        var entitiesMeta = getEntityMeta(dataPath, previousResult, ['id', '__typename']);
                                        var newResult = createCustomDeepResultObject(dataPath, (_b = {},
                                            _b[dataType] = filterUniqueIds ? filterBy(nodesArray, 'id') : nodesArray,
                                            _b.pageInfo = newPageInfo,
                                            _b), entitiesMeta);
                                        if (setScrollLoading)
                                            setScrollLoading(false);
                                        return newNodes.length ? newResult : previousResult;
                                    }
                                })];
                        });
                    }); })];
                case 1:
                    _e.sent();
                    return [2 /*return*/];
            }
        });
    }); };
};
export var getEdgeNodes = function (dataPath) {
    return compose(pluck(NODE_PATH), pathOr([], __spreadArray(__spreadArray([], dataPath, true), [EDGES_PATH], false)));
};
export var getNodes = function (dataPath) {
    return pathOr([], __spreadArray(__spreadArray([], dataPath, true), [NODES_PATH], false));
};
